import { DatePicker } from '@mui/x-date-pickers/DatePicker'

interface FilterDatePickerProps<
  TFilters extends Record<string, any>,
  K extends keyof TFilters,
> {
  label: string
  filterKey: K
  value: TFilters[K]
  onFilterChange: (filter: Partial<TFilters>) => void
}

export function FilterDatePicker<
  TFilters extends Record<string, any>,
  K extends keyof TFilters,
>({
  label,
  filterKey,
  value,
  onFilterChange,
}: FilterDatePickerProps<TFilters, K>) {
  return (
    <DatePicker
      label={label}
      onChange={(e) => onFilterChange({ [filterKey]: e } as Partial<TFilters>)}
      value={value}
      displayWeekNumber
      slotProps={{
        field: { clearable: true },
        textField: {
          variant: 'standard',
          fullWidth: true,
        },
      }}
    />
  )
}
